import { render } from "./DescriptionTabView.vue?vue&type=template&id=4755a04c"
import script from "./DescriptionTabView.vue?vue&type=script&lang=js"
export * from "./DescriptionTabView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__